import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Route, Routes } from "react-router-dom";
import SnackbarAlert from "./components/snackbar/index";
import { constants } from "./constants/variables";
import Home from "./containers/home";
import PrivacyPolicy from "./containers/privacyPolicy";
import TermsConditions from "./containers/termsConditions";
import TariffGuide from "./containers/tariffGuide";
import VoipTermsConditions from "./containers/voipTermsConditions";
import CallCharges from "./containers/callCharges";
import InternationalCallCharges from "./containers/internationalCallCharges";
import CardPayment from "./containers/cardPayment";
import DevelopmentService from "./containers/developmentService";

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: ["Poppins", "Raleway"].join(","),
    },
    button: {
      fontFamily: ["Poppins", "Raleway"].join(","),
    },
    input: {
      fontFamily: ["Poppins", "Raleway"].join(","),
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path={"/"} element={<Home />} />
        <Route path={"/privacy-policy"} element={<PrivacyPolicy />} />
        <Route path={"/terms-&-conditions"} element={<TermsConditions />} />
        <Route
          path={"/voip-terms-&-conditions"}
          element={<VoipTermsConditions />}
        />
        <Route path={"/card-payment"} element={<CardPayment />} />
        <Route path={"/call-charges"} element={<CallCharges />} />
        <Route
          path={"/international-call-charges"}
          element={<InternationalCallCharges />}
        />
        <Route path={"/tariff-guide"} element={<TariffGuide />} />
        <Route path={"/development-services"} element={<DevelopmentService />} />
      </Routes>
      <SnackbarAlert
        ref={(ref) => {
          constants.snackRef = ref;
        }}
      />
    </ThemeProvider>
  );
}

export default App;
